  angular
    .module('fca-used')
    .component('infoModal', {
      bindings: {
        closeAnywhere: '@',
        doShow: '=',
        hideContent: '<?',
        title: '@'
      },
      transclude: true,
      templateUrl: 'app/modal/info-modal.html'
    });
